export default __webpack_public_path__ + "static/backgroundGallery-3d49ac4492b6a75849963965aeb22506.jpg";